/* @ngInject */
function LicenseCardSimplifiedController ($scope, $rootScope, AdminService, ToastService) {
  $scope.graphicColor = 'default'

  const api = {
    _buildGraphic,
    _getPercentage,
    _defineGraphicColor,
    _getUsersCount
  }
  this.getApi = () => api

  activate()

  function activate () {
    $rootScope.getUserCompany().then(() => {
      // this makes sure that we have oUserCompany property inside $rootScope object
      api._getUsersCount()
    })
  }

  const deregisterLicenseCardUpdate = $scope.$on('license-card.update', () => {
    api._getUsersCount()
  })

  $scope.$on('$destroy', () => {
    deregisterLicenseCardUpdate()
  })

  $scope.getAvailablePercentage = (maxLicenses, convertToInt) => {
    return api._getPercentage($scope.totalAvailable, maxLicenses, convertToInt)
  }

  function _getPercentage (value, total, convertToInt) {
    let res = (100 * value) / total

    if (res < 0) {
      res = 0
    }

    return convertToInt ? parseInt(res) : res
  }

  function _buildGraphic () {
    const graphic = $('.license-card-simplified-container .license-graphic')
    let pendingPercentage = $scope.pendingUsers
      ? api._getPercentage($scope.pendingUsers, $rootScope.oUserCompany.maxLicenses)
      : 0
    let activePercentage = $scope.activeUsers
      ? api._getPercentage($scope.activeUsers, $rootScope.oUserCompany.maxLicenses)
      : 0
    let unavailablePercentage = $scope.totalUnavailable
      ? api._getPercentage($scope.totalUnavailable, $rootScope.oUserCompany.maxLicenses)
      : 0
    const totalPercentage = $scope.totalAvailable
      ? api._getPercentage($scope.totalAvailable, $rootScope.oUserCompany.maxLicenses)
      : 0

    if (unavailablePercentage > 100) {
      pendingPercentage = api._getPercentage(pendingPercentage, unavailablePercentage)
      activePercentage = api._getPercentage(activePercentage, unavailablePercentage)
      unavailablePercentage = 100
    }

    if ($scope.pendingUsers) {
      graphic.find('.pending').css('width', `${pendingPercentage}%`)
    }

    if ($scope.activeUsers) {
      const cssValue = $scope.pendingUsers ? `calc(${activePercentage}% + 12px)` : `${activePercentage}%`
      graphic.find('.active').css('width', cssValue)

      if ($scope.pendingUsers) {
        graphic.find('.active').css('margin-left', '-12px')
      }
    }

    if ($scope.totalUnavailable) {
      graphic.find('.total').css('width', `${unavailablePercentage}%`)
    }

    if ($scope.totalAvailable) {
      const cssValue =
        $scope.pendingUsers || $scope.activeUsers ? `calc(${totalPercentage}% + 12px)` : `${totalPercentage}%`
      graphic.find('.available').css('width', cssValue)

      if ($scope.pendingUsers || $scope.activeUsers) {
        graphic.find('.available').css('margin-left', '-12px')
      }
    }
  }

  function _defineGraphicColor () {
    const available = $scope.getAvailablePercentage($rootScope.oUserCompany.maxLicenses)

    if (available < 10) {
      $scope.graphicColor = 'critical'
    } else if (available < 30) {
      $scope.graphicColor = 'alert'
    } else {
      $scope.graphicColor = 'default'
    }
  }

  function _getUsersCount () {
    AdminService.filterUsersCount({ hideInternalUsers: true })
      .then(res => {
        $scope.activeUsers = parseInt(res.active)
        $scope.pendingUsers = parseInt(res.pending_invite)
        $scope.totalUnavailable = $scope.activeUsers + $scope.pendingUsers

        $scope.totalAvailable = $rootScope.oUserCompany.maxLicenses - $scope.totalUnavailable

        api._buildGraphic()
        api._defineGraphicColor()
      })
      .catch(ToastService.defaultErrorToast)
  }
}

export { LicenseCardSimplifiedController }
